export type WorldSpaceId = 'basecamp' | 'market' | 'arctic-port' | 'observatory' | 'library' | 'fridge' | 'news' | 'world-hub';

export interface WorldSpaceDefinition {
  id: WorldSpaceId;
  title: string;
  shortTitle: string;
  eyebrow: string;
  copy: string;
  actionLabel: string;
  route: string;
  asset: string;
  mobileAsset: string;
  emotion: string;
  icon: string;
  order: number;
}

const asset = (name: string) => `/assets/world-spaces/${name}_v1.webp`;
const mobileAsset = (name: string) => `/assets/world-spaces/${name}_v1_960.webp`;

export const WORLD_SPACES: WorldSpaceDefinition[] = [
  {
    id: 'basecamp', order: 1, title: '스노우 마운틴 베이스캠프', shortTitle: '베이스캠프', eyebrow: '오늘의 출발점',
    copy: '기록·미션·퀴즈 중 오늘 할 일 하나를 정하고 작은 성공을 시작해요.', actionLabel: '오늘의 첫 미션', route: '/child/home',
    asset: asset('basecamp_training'), mobileAsset: mobileAsset('basecamp_training'), emotion: '통제감', icon: '/assets/ui-icons/mrm_ui_12a_mission_v01.png',
  },
  {
    id: 'market', order: 2, title: '스노우 마켓 광장', shortTitle: '마켓', eyebrow: '비교하고 선택하기',
    copy: '가격과 필요를 비교하며 소비·저축·나눔 중 나에게 맞는 선택을 연습해요.', actionLabel: '선택 미션 하기', route: '/child/missions',
    asset: asset('market_square'), mobileAsset: mobileAsset('market_square'), emotion: '자기발견', icon: '/assets/ui-icons/mrm_ui_04d_other_v01.png',
  },
  {
    id: 'news', order: 3, title: '뉴스 스퀘어', shortTitle: '뉴스 광장', eyebrow: '오늘의 경제 날씨',
    copy: '어려운 경제기사를 한 줄로 읽고, 설옹의 질문으로 의미를 발견해요.', actionLabel: '오늘 뉴스 보기', route: '/child/concepts/economy',
    asset: asset('news_square'), mobileAsset: mobileAsset('news_square'), emotion: '이해', icon: '/assets/ui-icons/mrm_ui_12d_concept_v01.png',
  },
  {
    id: 'library', order: 4, title: '스노우볼 경제도서관', shortTitle: '경제도서관', eyebrow: '사라진 페이지 복원',
    copy: '경제 개념을 이야기와 그림으로 배우고 마법책의 지식 조각을 모아요.', actionLabel: '개념 한 장 배우기', route: '/child/concepts',
    asset: asset('economy_library'), mobileAsset: mobileAsset('economy_library'), emotion: '유능감', icon: '/assets/ui-icons/mrm_ui_07_missiontip_v01.png',
  },
  {
    id: 'observatory', order: 5, title: '오로라 크리스탈 관측소', shortTitle: '관측소', eyebrow: '숫자와 흐름 관찰',
    copy: '가격·뉴스·그래프의 변화를 관찰하고 미래를 단정하지 않는 연습을 해요.', actionLabel: '경제 흐름 관찰', route: '/child/concepts/economy',
    asset: asset('aurora_observatory'), mobileAsset: mobileAsset('aurora_observatory'), emotion: '판단력', icon: '/assets/ui-icons/mrm_ui_09_report_v01.png',
  },
  {
    id: 'arctic-port', order: 6, title: '북극 항구', shortTitle: '북극 항구', eyebrow: '세상과 연결되는 길',
    copy: '물건이 어디에서 오고 어떻게 이동하는지 무역·물류·현장 탐험으로 이해해요.', actionLabel: '패스포트 탐험', route: '/child/passport',
    asset: asset('arctic_port'), mobileAsset: mobileAsset('arctic_port'), emotion: '확장감', icon: '/assets/ui-icons/mrm_ui_02e_targetdate_v01.png',
  },
  {
    id: 'fridge', order: 7, title: '시간의 냥장고 집', shortTitle: '냥장고 집', eyebrow: '노력과 기억 보관',
    copy: '오늘의 선택·수료증·배지와 가족의 응원을 시간이 지나도 꺼내볼 수 있게 보관해요.', actionLabel: '컬렉션 보기', route: '/child/fridge',
    asset: asset('snow_fridge_home'), mobileAsset: mobileAsset('snow_fridge_home'), emotion: '자부심', icon: '/assets/ui-icons/mrm_ui_10a_streakreward_v01.png',
  },
  {
    id: 'world-hub', order: 8, title: 'MRM 스노우 월드', shortTitle: '월드 허브', eyebrow: '나만의 탐험 지도',
    copy: '열린 공간과 다음 잠금 조건을 한눈에 보고 오늘 갈 곳을 직접 선택해요.', actionLabel: '월드 둘러보기', route: '/child/world',
    asset: asset('world_hub'), mobileAsset: mobileAsset('world_hub'), emotion: '호기심', icon: '/assets/ui-icons/mrm_ui_02a_goalname_v01.png',
  },
];

export function worldSpace(id: WorldSpaceId): WorldSpaceDefinition {
  const found = WORLD_SPACES.find((space) => space.id === id);
  if (!found) throw new Error(`Unknown MRM world space: ${id}`);
  return found;
}
